import type { ChunkAckMessage, ChunkMessage } from '../shared/websocket/ChunkMessages';

type SendChunkAckMessage = (message: ChunkAckMessage) => void;

export class ChunkReceiver {
  private readonly id: string;

  private readonly totalChunks: number;

  private readonly send: SendChunkAckMessage;

  private chunks: Record<number, string> = {};

  private timeout: boolean = false;

  private timeoutPid: NodeJS.Timeout | undefined;

  constructor({
    id,
    totalChunks,
    sendChunkAck,
  }: {
    id: string;
    totalChunks: number;
    sendChunkAck: SendChunkAckMessage;
  }) {
    this.send = sendChunkAck;

    this.id = id;
    this.totalChunks = totalChunks;

    this.setTimeout();
  }

  private setTimeout() {
    if (this.timeoutPid) {
      clearTimeout(this.timeoutPid);
    }

    this.timeoutPid = setTimeout(() => {
      this.timeout = true;
    }, 10000);
  }

  static isChunkMessage(message: any): message is ChunkMessage {
    if (typeof message !== 'object') {
      return false;
    }

    return (
      typeof message.chunkNumber === 'number' &&
      typeof message.totalChunks === 'number' &&
      'type' in message &&
      message.type === 'chunk'
    );
  }

  public addChunk(chunkMessage: ChunkMessage) {
    this.chunks[chunkMessage.chunkNumber] = chunkMessage.chunk;

    this.send({
      type: 'chunk-ack',
      id: this.id,
      chunkNumber: chunkMessage.chunkNumber,
    });

    if (this.timeout) return;

    this.setTimeout();

    if (this.message) {
      if (this.timeoutPid) {
        clearTimeout(this.timeoutPid);
      }
    }
  }

  get message() {
    if (this.isCompleted) {
      return undefined;
    }

    return Object.values(this.chunks).join('');
  }

  get isCompleted() {
    return Object.keys(this.chunks).length !== this.totalChunks;
  }

  dispose() {
    if (this.timeoutPid) {
      clearTimeout(this.timeoutPid);
    }
  }
}
